export type MobileAppMethodName =
    | "goToDeepLink"
    | "openLinkBrowser"
    | "openInBrowser"
    | "showChat"
    | "openPdf"
    | "refreshBalance";

type MobileAppInterfaceName = "generalIntegration";

import useWebviewDebugMode from "./utils/use-webview-debug";
const { initWebviewDebugMode, showEventAlert } = useWebviewDebugMode();

export function triggerMobileAppEvent(
    methodName: MobileAppMethodName,
    argument?: string,
    interfaceName?: MobileAppInterfaceName
): void;
export function triggerMobileAppEvent(
    methodName: string,
    argument?: string,
    interfaceName?: MobileAppInterfaceName
): void;
export function triggerMobileAppEvent(
    methodName: string,
    argument?: string,
    interfaceName: MobileAppInterfaceName = "generalIntegration"
): void {
    const anyWindow = window as any;

    // for iOS WebKit
    if (typeof anyWindow.webkit !== "undefined") {
        showEventAlert(interfaceName, methodName, argument);
        argument !== null && argument !== undefined
            ? anyWindow.webkit.messageHandlers[interfaceName].postMessage(
                  JSON.stringify({ type: methodName, parameters: argument })
              )
            : anyWindow.webkit.messageHandlers[interfaceName]?.postMessage(JSON.stringify({ type: methodName }));
    }

    // for Android WebView
    const androindInterface = anyWindow[interfaceName];
    if (androindInterface && androindInterface.hasOwnProperty(methodName)) {
        showEventAlert(interfaceName, methodName, argument);
        argument !== null && argument !== undefined
            ? androindInterface[methodName](argument)
            : androindInterface[methodName]();
    }
}

function initAutoMobileAppEvents() {
    document.querySelectorAll("[data-app-event]:not([data-app-event=''])").forEach((item) => {
        item.addEventListener("click", (e) => {
            e.preventDefault();
            const eventName = (e.currentTarget as HTMLElement).getAttribute("data-app-event");
            const argument = (e.currentTarget as HTMLElement).getAttribute("data-app-argument");

            triggerMobileAppEvent(eventName, argument);
        });
    });
}

export const isMobileApp = environment.isInAppView || false;

export function initMobileAppFeatures() {
    if (isMobileApp) {
        initWebviewDebugMode();
        initAutoMobileAppEvents();
    }
}
